import EquinorLogo from "./equinor-logo";
export default EquinorLogo;
